import * as React from "react";

import type { DesignaliProps } from "../../types";

export const StarAward01 = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M11.67,5.21c.14-.28.52-.28.66,0l.81,1.67c.05.11.16.19.27.21l1.77.29c.3.05.42.43.2.66l-1.27,1.33c-.08.09-.12.21-.1.33l.28,1.85c.05.31-.27.55-.54.41l-1.59-.85c-.11-.06-.23-.06-.34,0l-1.59.85c-.27.14-.58-.09-.54-.41l.28-1.85c.02-.12-.02-.25-.1-.33l-1.27-1.33c-.21-.22-.09-.61.2-.66l1.77-.29c.12-.02.22-.1.27-.21l.81-1.67Z" />
        <path d="M19,9c0,3.87-3.13,7-7,7s-7-3.13-7-7,3.13-7,7-7,7,3.13,7,7Z" />
        <path d="M13,16.34l1.63,4.31c.33.87.49,1.3.78,1.35.29-.04.64-.52.98-1.38.24-.62.37-.93.62-1.09.08-.05.16-.09.25-.12.29-.09.63,0,1.3.18.72.19,1.22.14,1.41,0,.06-.04,0,0,0,0,.12-.21-.04-.53-.35-1.17l-2.15-4.41" />
        <path d="M11,16.34l-1.63,4.31c-.33.87-.65,1.3-.94,1.35-.29-.04-.46-.47-.8-1.34-.24-.62-.39-.97-.64-1.14-.08-.05-.16-.09-.25-.12-.29-.09-.63,0-1.3.18-.72.19-1.22.14-1.41,0-.12-.21.04-.53.35-1.17l2.15-4.41" />
      </svg>
    );
  },
);

export default StarAward01;
